import React from 'react'
import './swap.css'
import Header from '../../components/Header/Header.jsx'
import SocialIconsContainer from '../../components/Container/SocialIconsContainer.jsx'
import TransactionSettings from '../../components/Popups/TransactionSettings.jsx'
import ConfirmationPopup from '../../components/Popups/ConfirmationPopup.jsx'
import SuccessPopup from '../../components/Popups/SuccessPopup.jsx'
import DisclaimerPopup from '../../components/Popups/DisclaimerPopup.jsx'
import {WalletContext} from '../../context/WalletContext'
import { GetMethod } from '../../NetworkCalls/Get'
import { PostMethod } from '../../NetworkCalls/Post'
import {onConnect} from '../../utils/WalletConnections'
import {TransferGDBX,ClaimContract} from '../../utils/ContractConnection'
import swal from "sweetalert";
function Swap() {
    const [swap,setSwap]=React.useState(false)
    const [Active,setActive]=React.useState(false)
    const [ConfirmActive,setConfrimActive]=React.useState(false)
    const [SuccessActive,setSuccessActive]=React.useState(false)
    const [value,setValue]=React.useState('')
    const [convertedValue,setConvertedValue]=React.useState('')
    const [err,setErr]=React.useState('')
    const [amount,setAmount]=React.useState('')
    const [hash,setHash]=React.useState('')
    const [slipage,setSlipage]=React.useState(10)
    const [minAmount,setminAmount]=React.useState(0)
    const [confirmLoader,setConfirmLoader]=React.useState(false)
    const [impact, setImpact]=React.useState(0)
    const [quotes, setQuotes] = React.useState({})
  
    const {walletAddress,setWalletAddress,auth,setAuth,EGBXbal,GDBXbal,setEGBXbal,setGDBXbal,provider,setProvider}=React.useContext(WalletContext)
    const onWalletConnect=()=>
    {
        onConnect().then(res=>
            {
                setWalletAddress(res.walletAddress)
                setAuth(res.auth)
                setValue(0)
                setConvertedValue(0)
                setGDBXbal(res.GDBX/10**18)
                setEGBXbal(res.EGBX)
                setProvider(res.Provider)
                
            }).catch(err=>
                {
                    swal({
                        title: "Error Found",
                        text: err.err,
                        type: "error",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        closeOnConfirm: false,
                      });
                })
    }
    const onClaim=()=>
    {
        console.log("CLAIM")
        return new Promise((resolve,reject)=>
        {
            const body={
                "token": swap?"EGBX":"GDBX",
                "amount": minAmount
            }
         PostMethod('claims',body,auth).then(res=>
            {
                console.log(res)
                ClaimContract(provider,walletAddress,res.result.formatted_amount,res.result.nonce,res.result.expires,res.result.signature,res.result.token.address).then(res=>{
                    resolve(res)
                }).catch(err=>
                    {
                        reject(err)
                    })
            }).catch(err=>
            {
                reject(err)
            }) 
        })
        
    }
    const onSwapAndClaim=()=>
    {
        onSwap().then(res=>
            {

                if(swap){
                    // const body=JSON.stringify({
                    //     in:{
                    //         token:swap?'GDBX':'EGBX',
                    //         amount:value
                    //         },
                    //     out:{
                    //         token:swap?'EGBX':'GDBX',
                    //         amount:convertedValue
                    //         },
                    //     hash:hash,
                    //     slippage:slipage?slipage/100:0,
                    //     tx: res.transactionHash,
                    // })
                    const body = JSON.stringify({
                        ...quotes,
                        tx: res.transactionHash,

                        
                    })
                    console.log(body)
                    PostMethod('swaps',body,auth).then(res=>
                        {
                            
                            swal({
                                title: "Success",
                                text: `You have received ${convertedValue} EGBX!`,
                                type: "success",
                                showCancelButton: false,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Ok",
                                closeOnConfirm: false,
                              });
                              GetMethod('balances',auth).then(res=>
                                {
                                 
                                    setEGBXbal(res[1].balance)
                                    setGDBXbal(GDBXbal-value)
                                })
                              setConfrimActive(false)

                        }).catch(err=>
                            {
                                swal({
                                    title: "Something went wrong!",
                                    text: "Something went wrong!",
                                    type: "error",
                                    showCancelButton: false,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Ok",
                                    closeOnConfirm: false,
                                  });
                                
                            })
                }
                else{
                    onClaim().then(res=>
                        {
                            setConvertedValue(0.0)
                            setValue(0.0)
                            setConfrimActive(false)
                            setSuccessActive(true)
                        }).catch(err=>
                            {
                                console.log(err)
                                swal({
                                    title: "Something went wrong!",
                                    text: "Something went wrong!",
                                    type: "error",
                                    showCancelButton: false,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Ok",
                                    closeOnConfirm: false,
                                  });
                                })
                            }
            })

       .catch(err=>
                {
                    console.log(err)
                    swal({
                        title: "Something went wrong!",
                        text: "Something went wrong!",
                        type: "error",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        closeOnConfirm: false,
                      });
                }).finally(() => {
                    setConfirmLoader(false)
                });
    }
    const onSwap=()=>
    {
        return new Promise((resolve,reject)=>
        {
            setConfirmLoader(true)
            if(swap)
            {
               SWAP_GDBX_TO_EGBX().then(res=>
                {
                    resolve(res)
                    
                }).catch(err=>
                    {
                        reject(err)
                    })
                   
            }
           else 
           {
            SWAP_EGBX_TO_GDBX().then(res=>
                {
                    resolve(res)
                }).catch(err=>
                    {
                        reject(err)
                    })
                }
        })
        
    }
    const SWAP_EGBX_TO_GDBX=()=>
    {
        return new Promise((resolve,reject)=>
        {
          
            // const body=JSON.stringify({
            //     in:{
            //         token:swap?'GDBX':'EGBX',
            //         amount:value
            //         },
            //     out:{
            //         token:swap?'EGBX':'GDBX',
            //         amount:convertedValue
            //         },
            //     hash:hash,
            //     slippage:slipage?slipage/100:0
            // })

            const body = JSON.stringify({
                ...quotes
            })
            console.log(body)

            PostMethod('swaps',body,auth).then(res=>
                {
                    resolve()
                }).catch(err=>
                    {
                        reject(err)
                    })
                  
        })
    }
    const SWAP_GDBX_TO_EGBX=()=>
    {
        return new Promise((resolve,reject)=>
        {
            TransferGDBX(provider,walletAddress,value).then(res=>
                {
                    resolve(res)
                }).catch(err=>
                    {
                        reject(err)
                      
                    })
        })
    }
    const wrapperSetSlipage = React.useCallback(val => {
       
        if(val>=0 && val<=100)
        {
            setSlipage(val);
        }

      }, [setSlipage]);
      
    React.useEffect(()=>
    {
        GetMethod(`quotes?in=${swap?'GDBX':'EGBX'}&in_amount=1&out=${swap?'EGBX':'GDBX'}&slippage=${slipage/100}`).then(res=>
            {
               setAmount(swap?`1 GDBX = ${res.out.amount} EGBX`:`1 EGBX = ${res.out.amount.toFixed(6)} GDBX`)
               setQuotes(res)
            })
      
    },[])

    React.useEffect(()=>
    {
       
        if(value=='')
        {
            setErr('Enter amount')
            setConvertedValue('')
        }
        else if(parseInt(value)<0)
        {
            setErr('Enter valid amount')
        }
        else
        {
            GetMethod(`quotes?in=${swap?'GDBX':'EGBX'}&in_amount=${value}&out=${swap?'EGBX':'GDBX'}&slippage=${slipage/100}`).then(res=>
                {
                    setHash(res.hash)
                    setConvertedValue(res.out.amount)   
                    setImpact(res.impact)
                    setminAmount(res.out.min_amount)
                    setQuotes(res)
                })
            if((swap && value<=GDBXbal) || (!swap && value<=EGBXbal))
            {
               
                setErr('')
            }
            else
            {
                setErr(`Insufficient ${swap?'GDBX':'EGBX'} Balance`)
            }
        
        }
    },[value,swap])

  return (
    <div className='body'>
<Header/>
<div className='swap'>

 <p>Swap</p>
<div className='card'>
    <div className='menu-container'>
    <img className='menu' src='/assets/Dots.png' onClick={()=>setActive(true)}/>
    </div>
    <div className='card-container'>
    <div className='card-inputcontainer'>
        <div className='inputcontainer-div'>
        <input placeholder='0.0' type='number' value={value}onChange={(e)=>setValue(e.target.value)} />
        <p>{swap?'$GDBX':'$EGBX'}</p>
        </div>
        {walletAddress && 
        <div className='card-balancecontainer'>
            <p>{`Balance:${swap?GDBXbal:EGBXbal}`}</p>
        </div>
        }
    </div>
    <div className='card-inputcontainer'>
    <div className='inputcontainer-div'>
        <input placeholder='0.0' value={convertedValue?convertedValue.toFixed(6):'0.0'} disabled />
        <p>{swap?'$EGBX':'$GDBX'}</p>
        </div>
        {walletAddress && 
        <div className='card-balancecontainer'>
            <p>{`On-Chain Balance: ${GDBXbal}`}</p>
            <p>{`Off-Chain Balance: ${EGBXbal}`}</p>
        </div>
        }
    </div>
    <div className='swapbutton' onClick={()=>setSwap(!swap)}>
        <img src='/assets/swapArrow.png' className='swaparrow'/>
    </div>

    </div>
    <div className='card-container'>
    <p className='amount'>{amount}</p>
    {walletAddress?
       <button className='connectWallet' disabled={err?true:false} onClick={()=>setConfrimActive(true)}>
        {
        err?
      
        err:
        <p>
       Swap
        </p>
           
       }
    </button>
    :
    <button className='connectWallet' onClick={()=>onWalletConnect()} >
    {
    <p>
        Connect Wallet
    </p>
    }
    </button>
    }
 
    </div>
</div>
</div>
<SocialIconsContainer/>
{Active && <TransactionSettings setSlipage={wrapperSetSlipage} slipage={slipage} onClose={()=>setActive(false)} /> }
{SuccessActive && <SuccessPopup onClose={()=>setSuccessActive(false)}/>}
{ConfirmActive &&
    <ConfirmationPopup onSwap={()=>onSwapAndClaim()}
        onClose={()=>setConfrimActive(false)} 
        convertedValue={convertedValue} 
        value={value} 
        swap={swap} 
        minAmount={minAmount}
        amount={amount}
        impact={impact}
        loader={confirmLoader} /> }

    </div>
  )
}

export default Swap